import React from "react";
import UserIcon from "./../../../assets/icons/lsq_user_icon.svg";
import OpportunityIcon from "./../../../assets/icons/lsq_opportunity_icon.svg";
import { handleLeadIdClick, handleOpportunityIdClick } from "../helper/helper";
import "./AssociatedEntity.css";

const AssociatedEntity = ({ event = {} }) => {
  const { relatedEntity, category, auditDetails } = event;
  if (!relatedEntity) return null;
  const isUpcoming =
    category === 1 ||
    (auditDetails?.dueDateLocalTime &&
      new Date(auditDetails?.dueDateLocalTime) - new Date() <= 15 * 60 * 1000 &&
      auditDetails?.endDateLocalTime &&
      new Date(auditDetails?.endDateLocalTime) > new Date());
  const {
    relatedSubEntityIsOpportunity,
    relatedSubEntityName,
    relatedEntityIdName,
  } = relatedEntity;
  const handleClick = relatedSubEntityIsOpportunity
    ? handleOpportunityIdClick
    : handleLeadIdClick;
  const entityName = relatedSubEntityIsOpportunity
    ? relatedSubEntityName
    : relatedEntityIdName;
  const Icon = relatedSubEntityIsOpportunity ? OpportunityIcon : UserIcon;

  return (
    entityName && (
      <span
        className={`associated-entity ${isUpcoming && "is-upcoming"}`}
        onClick={(e) => {
          e.stopPropagation();
          handleClick(event);
        }}
      >
        <img src={Icon} alt="associated entity" />
        <label className="overflow-ellipsis ng_p_2_sb">{entityName}</label>
      </span>
    )
  );
};

export default AssociatedEntity;
